import React from 'react'
import {Spacer} from '../../../../Common/Components/Spacer'
import {
  MBContentNoteWithMarkTypography,
  MBContentSubTitleTypography,
} from '../../Atoms/Typographies'

type ContentTopMessageProps = {
  marginBottom?: string
  note?: string
  children: React.ReactNode
}
export const ContentTopMessage: React.VFC<ContentTopMessageProps> = (props) => {
  return (
    <div>
      <MBContentSubTitleTypography>
        {props.children}
      </MBContentSubTitleTypography>
      {
        props.note &&
        <Spacer mt={'10px'} mb={'16px'}>
          <MBContentNoteWithMarkTypography note={props.note}/>
        </Spacer>
      }
    </div>
  )
}
